














































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import $ from "jquery";

import independentLandmark from "@/components/independentLandmark.vue";
import landmarkEnterprise from "@/components/landmarkEnterprise.vue";
import cultureHeritage from "@/components/cultureHeritage.vue";
import vrVideo from "@/components/landmarkVrVideo.vue";
import landmarkShop from "@/components/landmarkShopChild.vue";
import { getCmsLandmarkDetail, headerData } from "@/axios";

@Component({
  name: "landmarkVr",
  components: {
    "v-independentLandmark": independentLandmark,
    "v-landmarkEnterprise": landmarkEnterprise,
    "v-cultureHeritage": cultureHeritage,
    "v-vrVideo": vrVideo,
    "v-landmarkShop": landmarkShop,
  },
})
export default class extends Vue {
  private logoImg: any = "";

  // 导航索引
  private navIndex: any = -1;
  private navIndexOld: any = -1;
  // 导航数据
  private navData: any = [];

  private inputPageHomeData: any = null;
  private inputPageEnterpriseData: any = null;
  private inputCultureHeritageData: any = null;
  private inputVrVideoData: any = null;
  private inputLandmarkShopData: any = null;
  private searchValue: any = "";

  private landmarkTitle: any = "";
  private landmarkId: any = "";
  private landmarkName: any = "";
  private scrollBar: any = true;
  // private showFooter: any = false;

  // private getImgUrl(id: any) {
  //   return require('@/assets/images/landmarkNavIcon' + id + '.png');
  // }

  // 改变nav索引
  private changeNavIndex(id: any) {
    console.log("changeNavIndex====", id);

    this.navIndex = id;
    this.scrollBar = true;
    this.setSize();

    if (id != 0) {
      this.navIndexOld = id;
    }
  }

  private setSize() {
    this.$nextTick(() => {
      var viewHeight: any = $(window).height();
      var contentHeight: any = $(".template-box").height();
      if (viewHeight > contentHeight) {
        this.scrollBar = false;
      } else {
        this.scrollBar = true;
      }
    });
  }

  created() {
    window.onresize = () => {
      this.setSize();
    };

    this.landmarkId = this.$route.query.landmarkId;

    headerData({
      landmark_id: this.landmarkId,
    }).then((res: any) => {
      let data = res.data.data;
      this.navData = data.headerData;
      this.landmarkTitle = data.title;
      this.landmarkName = data.headerData[0].column;
    });

    // 首页数据
    if (this.landmarkId) {
      getCmsLandmarkDetail({
        id: this.landmarkId,
      })
        .then((res: any) => {
          let data = res.data.data;
          // this.navData = data.headerData.topNav;
          this.inputPageHomeData = data;
          this.inputPageEnterpriseData = data.pageEnterprise;

          // console.log('this.inputPageEnterpriseData---------sssssss',this.inputPageEnterpriseData)

          this.inputCultureHeritageData = data.pageCulture.landmarkCultureArray;
          this.inputVrVideoData = data.pageVrVideo;
          this.inputLandmarkShopData = data.pageShop[0];

          this.setSize();

          // console.log('ts----',data.pageCulture.landmarkCultureArray)

          // console.log('getCmsLandmarkDetail--------------------',data)
        })
        .catch((error: any) => {});
    }
  }

  private toIndex() {
    this.$router.push({
      path: "/",
    });
  }

  private toOther() {
    window.location.href = "https://cms.fjyoulunsw.com/web_new/#/login";
  }

  private toSearch(value: any) {
    if (value.length != 0) {
      this.$router.push({
        path: "/search",
        query: {
          searchValue: value,
          // landmarkId: this.landmarkId
        },
      });
    }
  }

  private closeLandmarkDialog() {
    this.landmarkDialogShow = false;
  }

  private landmarkDialogShow: any = false;
  private landmarkUrl: any = "";

  private showLandmark() {
    // var url =
    //   "https://cms.fjyoulunsw.com/sign_vr/#/?goodsId=" + this.landmarkId + "";
    var url =
      document.location.protocol +
      "//cms.fjyoulunsw.com/sign_vr_v2/#/aPicture?id=1&landmarkId=" +
      this.landmarkId +
      "&landmarkName=" +
      this.landmarkName;
    this.landmarkUrl = url;
    this.landmarkDialogShow = true;
  }

  private toLandmarkIndex(index: any) {
    if (index == 0) {
      this.showLandmark();
    }
  }
}
